import { AVAILABLE_ACTIONS_QUERY_KEYS, QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { wildcardInvalidateQuery } from "@/lib/utils";
import { useQueryClient } from "@tanstack/react-query";

interface UpdateShiftStatusParams {
  isOnShift: boolean;
}

interface UpdateShiftStatusResponse {
  openLiveEncounterIds: string[];
}

export const useUpdateShiftStatus = () => {
  const queryClient = useQueryClient();

  return useApiMutation<UpdateShiftStatusResponse, UpdateShiftStatusParams>({
    mutationOptions: {
      mutationKey: ["provider", "remove-patient"],
      mutationFn: (params) => {
        return axiosInstance.post("/providers/shift-status", params);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Provider.ShiftStatus.DEFAULT,
        });
        for (const queryKey of AVAILABLE_ACTIONS_QUERY_KEYS) {
          wildcardInvalidateQuery(
            queryClient,
            queryKey.filter((key) => key !== undefined),
          );
        }
      },
    },
  });
};
